module.exports = __webpack_public_path__ + "img/services.1faa7e53.webp";